import React from 'react';
import { View } from 'react-native';

export default function MapScreenMobile() {
  return <View>Not applicable for Web</View>;
}
